import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";
import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";
import { HStack } from "@formant/ui/component/common/HStack";
import { Icon } from "@formant/ui/component/common/Icon";

import { operateStore, streamCurrentValueStore } from "../../../stores";
import { getBitsetsFromStreamConfig } from "../../../utils/getBitsetsFromStreamConfig";
import { Timer } from "../../common/Timer";
import * as styles from "./index.scss";
import { PulseMetric } from "./PulseMetric";
import { StatusItem } from "./StatusItem";
import { TeleopLatencyIndicator } from "./TeleopLatencyIndicator";
import { WebRTCConnectionStatus } from "./WebRTCConnectionStatus";

export interface IPulseBarProps {
    configuration?: IDeviceTeleopConfiguration;
    className?: string;
}

@observer
export class PulseBar extends Component<IPulseBarProps> {
    public render() {
        const { session, share } = operateStore;
        if (!session?.deviceId) {
            return false;
        }
        const { deviceId } = session;
        const { className, configuration } = this.props;

        const currentValues =
            (streamCurrentValueStore.map({
                deviceIds: [deviceId],
            }) || {})[deviceId] || {};

        const currentData = Object.keys(currentValues).map(
            name => currentValues[name],
        );

        const batteryStreamName = currentData.find(
            _ => _.streamType === "battery",
        )?.streamName;

        const streams = getBitsetsFromStreamConfig(
            deviceId,
            configuration,
            "observe",
        );

        const statuses = (streams || []).map(_ => (
            <StatusItem
                key={`${_.streamName}.${_.label}`}
                session={session}
                stream={_}
            />
        ));

        return (
            <HStack
                vAlign="center"
                hAlign="space-between"
                className={classnames(styles["pulse-bar"], className)}
            >
                <Timer interval={duration.second} onTick={this.onTick} />
                <HStack
                    vAlign="center"
                    hAlign="center"
                    className={styles["icon-wrapper"]}
                >
                    <Icon name="health" className={styles.icon} />
                </HStack>

                <PulseMetric
                    deviceId={deviceId}
                    streamName="$.host.cpu"
                    label="CPU"
                    valueSuffix="%"
                    min={0}
                    max={100}
                    streamType="numeric set"
                    currentData={currentData}
                />
                <PulseMetric
                    deviceId={deviceId}
                    streamName="$.host.memory"
                    label="MEM"
                    valueSuffix="%"
                    min={0}
                    max={100}
                    streamType="numeric set"
                    currentData={currentData}
                />
                {batteryStreamName && (
                    <PulseMetric
                        deviceId={deviceId}
                        streamName={batteryStreamName}
                        label="BAT"
                        valueSuffix="%"
                        min={0}
                        max={100}
                        streamType="battery"
                        currentData={currentData}
                    />
                )}
                <TeleopLatencyIndicator
                    disableHighPingWarning={
                        configuration?.disableHighPingWarning
                    }
                />
                <WebRTCConnectionStatus />
                {!share && statuses}
            </HStack>
        );
    }

    private onTick = () => {
        this.forceUpdate();
    };
}
